import { useSharedDates } from '@contexts/sharedDates'
import { useDate } from '@hooks/dates'

import {
  DayOfTheWeekLabel,
  FlatListButton,
  FlatListContainer,
  SelectionLine,
  Shadow,
  WeekListRow,
} from './styles'

export function WeekList() {
  const { selectedDate, selectedWeekDay, setSelectedWeekDay } = useSharedDates()

  const { getWeekRange, getWeekList } = useDate()
  const { weekStart } = getWeekRange(selectedDate)
  const dates = getWeekList(weekStart)

  return (
    <FlatListContainer>
      <WeekListRow>
        {dates.map((item) => (
          <div key={item.weekDay}>
            <Shadow />
            <FlatListButton
              onClick={() =>
                setSelectedWeekDay({
                  date: item.date ?? new Date(),
                  weekDay: item.weekDay,
                })
              }
            >
              <DayOfTheWeekLabel>{item.weekDay}</DayOfTheWeekLabel>
            </FlatListButton>
            {item.weekDay === selectedWeekDay.weekDay && <SelectionLine />}
          </div>
        ))}
      </WeekListRow>
    </FlatListContainer>
  )
}
